let env = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_HOST: 'http://localhost:4000',
  REACT_APP_SENTRY_DSN: 'https://4bfd0668ed494c80a6fac088b4b0749e@sentry.io/1289219',
  REACT_APP_360_HOST: 'http://localhost:8081',
  REACT_APP_GAME_HOST: 'http://localhost:8080',
  REACT_APP_HOST: 'http://localhost:3000',

  REACT_APP_LANGUAGE: 'es',

}


console.log(process.env.REACT_APP_LANGUAGE)
if (env.NODE_ENV === 'production') {
  env = {
    ...env,
    REACT_APP_API_HOST: 'https://api.webtips.healthcare',
    REACT_APP_SENTRY_DSN: 'https://4bfd0668ed494c80a6fac088b4b0749e@sentry.io/1289219',
    REACT_APP_360_HOST: 'https://webtour.webtips.healthcare',
    REACT_APP_GAME_HOST: 'https://webgames.webtips.healthcare',
    REACT_APP_HOST: 'https://lwebtips.webtips.healthcare',
  }
}

export {env}



// WEBPACK FOOTER //
// ./src/utils/env.ts